import React from 'react';
import { FormattedMessage } from 'react-intl';
import liliHappy from '../../../assets/icons/LILI_HAPPY.svg';
import './TopBanner.component.scss';

export function TopBannerComponent(props: any) {
  const {noImage} = props;
  return (
    <div className='top-banner d-flex justify-content-start flex-nowrap flex-row align-items-center'>
      <FormattedMessage id='atoms.top_banner.label_2'>
        {txt => (
          <h2>
            <span>
              <FormattedMessage id='atoms.top_banner.label_1' />
            </span>
            {txt}
          </h2>
        )}
      </FormattedMessage>
      {!noImage && <img src={liliHappy} alt='' />}
    </div>
  );
}
